module.exports = __webpack_public_path__ + "fonts/visuelt-pro-light.02689dc2.eot";